// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3Vgmr","messages":"Chat_messages__2skYb","dateDivider":"Chat_dateDivider__FO6sf"};